import { FunctionComponent } from "react";

import { useTranslation } from "react-i18next";

import { faLightbulb } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "@/components/Icon/Icon";
import { Information } from "@/components/Information/Information";

/** Amber advisory chip shown on the first search profile: "Start narrow, then broaden". */
export const AdvisoryChip: FunctionComponent = () => {
	const { t } = useTranslation();
	const ts = (key: string) => t(`defineIcps.defineIcp.${key}`);

	return (
		<span className="inline-flex items-center gap-1.5 rounded-full border border-tag-warning-border bg-tag-warning-light px-2.5 py-1 text-xs font-semibold text-tag-warning-dark">
			<Icon className="w-3 h-3" icon={faLightbulb} />
			{ts("advisoryStartNarrow")}
			<Information information={ts("advisoryStartNarrowInfo")} />
		</span>
	);
};
